/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import Spinner from '~/components/Spinner';
import { Button } from 'react-toolbox/lib/button';
import { getByCatalogID3DCart, update } from '~/actions/products';
import style from './style.scss';

class Product extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: !props.product,
    };
  }

  componentDidMount() {
    if (!this.state.product) {
      getByCatalogID3DCart(this.props.dispatch, this.context.apiClient, this.props.match.params.id)
        .then(() => this.setState({ loading: false }))
        .catch(() => this.setState({ loading: false }));
    }
  }

  save() {
    update(
      this.props.dispatch,
      this.context.apiClient,
      this.props.match.params.id,
      Object.keys(this.state).filter(k => ['stock', 'stockType3DCart'].includes(k))
        .reduce((s, v) => ({ ...s, [v]: this.state[v] }), {})
    ).then(() => this.setState({ stock: null, stockType3DCart: null }));
  }

  renderProduct() {
    const product = this.props.product.toJS();
    console.info(this.state.stock);
    return (
      <div className={style.container}>
        <div className={style.title}>{product.raw.SKUInfo.Name}</div>
        <div className={style.image} style={{ backgroundImage: `url(https://www.partynuts.com/${product.raw.ThumbnailFile})` }} />
        <div className={style.cost}>$ {product.raw.SKUInfo.Price}</div>
        <div className={style.stock}>
          <div>
            {Object.keys(this.props.locations).map(l => <div key={l} className={style.location}>
              {this.props.locations[l].name}: <input
                value={(this.state.stock && this.state.stock[l]) || product.stock[l] || 0}
                onChange={e => this.setState({
                  stock: Object.assign(Object.keys(this.props.locations).reduce((s, v) => ({
                    ...s, [v]: (this.state.stock && this.state.stock[v]) || product.stock[v] || 0
                  }), {}), { [l]: parseInt(e.target.value, 10) })
                })}
              />
            </div>)}
          </div>
          <div className={style.stockType}>
            <div>Public stock</div>
            <Button
              label="Actual stock"
              accent
              raised={(this.state.stockType3DCart || product.stockType3DCart) === 'actual'}
              onClick={() => this.setState({ stockType3DCart: 'actual' })}
            />
            <Button
              label="Infinite stock"
              accent
              raised={(this.state.stockType3DCart || product.stockType3DCart) === 'infinite'}
              onClick={() => this.setState({ stockType3DCart: 'infinite' })}
            />
          </div>
          <Button
            onClick={() => this.save()}
            label="Save"
            icon="save"
            primary
            raised
            style={{ marginTop: '10px' }}
          />
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return <Spinner />;
    }
    if (this.props.product) {
      return this.renderProduct();
    }
    return <div style={{ padding: '10px' }}>Product not found</div>;
  }
}

const mapStateToProps = (state, props) => ({
  product: state.getIn(['products', 'products', props.match.params.id], false),
  locations: state.getIn(['locations', 'locations']).toJS(),
});

export default connect(mapStateToProps)(Product);



// WEBPACK FOOTER //
// ./app/pages/Product/index.js